import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemUsersInactivationComponent } from './system-users-inactivation.component'
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { HistoryUsersInactivationComponent } from './history-inactivation-users/history-users-inactivation.component';
import { InactivateUsersComponent } from './inactivate-users/inactivate-users.component';


@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
  ],
  declarations: [
    InactivateUsersComponent,
    SystemUsersInactivationComponent,
    HistoryUsersInactivationComponent
  ],
})
export class SystemUSersInactivationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/system-users-inactivation.module.ts